import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hustle, life, and Bernoulli trials",
  "description": "",
  "published": "2019-07-02T00:00:00.000Z",
  "redirect_from": ["/blog/hustle-life-and-bernoulli-trials/swizec/9146"],
  "categories": "Learning, Personal",
  "hero": "./img/techletter.app-screenshot-1562081681779.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I watched this short Casey Neistat video again this morning and it made me think about hustle. Does hustle actually lead to success, or is it all just luck?`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=L9VBpbnXhWk"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2040c0%2035%201%2061%202%2054l2-3c2-1%202-1%202%206%200%206%200%207-2%208l-2%202v2c-1%200-1%201%201%201%201%201%201%201-1%201H0v114h401v-60a1226%201226%200%2000-3-60c-2%202-6%201-6-1l-2-11V83h5l5-1-5-1c-5%200-6-1-6-7l-1-3-1%205%201%205h-51l25%201%2025%201%203%2019-1%204c-2%200-2%201-2%205v5h7l7%201h-7c-9%200-9%202%200%202l7%201h-7c-9%200-9%202%200%202%205%201%204%201-4%201-10%200-11%200-9%203l1%2016-1%205v3h-8c-8%200-9%200-9%202s1%202%209%202l9%201%207%201%207%201v3c0%202%201%203%202%203%202%200%202%201%202%208l-1%208-6%203-1%201-1%202c2%201%201%203-1%203-1%201-2%201-1%202%200%202%200%202-2%202h-4l-2%202-7%201c-7%200-9-2-9-7s-3-8-8-8c-7%200-9%201-8%203l1%203c-1%201%200%202%201%203s1%201-1%203l-1%204-3%204c-4%202-4%202-6%200-2-1-13-2-14%200-2%203-22%206-23%203-3-6-2-6%205-6%2010%200%2011%200%2012-8%200-9-1-9-14-9h-11v-57h-20l-43%201h-23v56h-28V47h95v23h-67v31h59v20h14c12%200%2013%200%2013-2s-1-2-5-2l-4-1h9v-8c0-6%200-7-1-6-2%201-2%201-2-2s-1-4-5-4c-5-1-5-1-6%209v7l-1-9v-8h-5l-4-1h9l1-6c1-5%201-5%201-2%200%204%202%207%202%204l2-2%201-2c0-3%200-4%204-4l5-1h-5c-3%200-4%200-4-2s-1-3-6-3l-5-1%205-1c5%201%206%200%206-4%200-2%200-2%204-1h4V47h49l49%201-1%209c0%2012%200%2013%204%2014l4-1%201-36V0h-3l-4%201-1%201V1l-8-1c-9%200-9%200-9%202%200%203%200%203%205%202%205%200%205%200%202%201l-4%202c-3%202-4%200-4-4V0H219l-2%204c-1%203-2%204-3%202V4l2-2c1-2%201-2-7-2-7%200-8%200-7%202l3%201%202%201-1%201-2%201h-2l-2-2-1-1-1-1-1-1h-7A1753%201753%200%200050%203c8%200%206%201-3%201-7%201-7%201-7-2l1-2H0v40M193%202l-8%201c-8%200-12%201-11%202l-2%202c-5%202-3%204%205%204%203%200%203%200%202%201-2%201-1%201%204%201l6-1c1-3%203-2%204%200l-1%203-2%203-10%201c-11%200-7%202%205%202%206%200%207%200%207%202l2%201%203%201h6c2%200%202%200%202-2%200-3-1-5-3-4-2%200-4-3-4-6l-1-2-1-5c0-3-1-4-2-5l-1%201m31%205c-1%203-2%204-4%205-3%201-4%202-5%204l-3%204c-2%200-2%204%200%206%201%201%202%200%203-1h26c5%200%200-2-6-2-10%200-12-2-3-2s8-1-3-3h-8l-2%201h-2l2-2c2-2%203-3%209-3l8-1c0-1%202-2%205-2h5l-3-2-2-1V6c0-2-4-3-12-3h-5v4m125-1c-4%203-7%206-7%208l-1%202-2%202c0%202%203%203%207%204%201%201-3%201-8%201-9%200-14%201-14%203l1%201c1-1%201%200%201%202%200%203%202%2011%203%209h2l5-3%203-2-5-4c-7-4-6-4-6-5l6%203%206%203%203%202c3%203%204%202%204-1%200-5%200-7%201-6l1-7c0-11%200-10%202-10%204%202%208%202%2011%201l4-1h-4c-6%200-9-1-10-2h-3M79%2022l-7%201c-5%200-6%200-5%201l1%203c0%203%202%203%206%201%209-6%2012-6%202%201-6%204-5%206%201%206%202%200%203%201%203%202%200%202%202%201%203-1l1-1c0%203%208%204%2015%202l5-2-5-5c-6-6-6-6-1-6%203-1%203-1-1-1-6%200-9%201-9%203l-2%201c-2%200-2%200-1-1%203%200%202-1-1-3s-3-2-5-1m233%203c5%200%205%201%201%204l-3%203%203%201%204%202c3%201%205%201%206-1%202-2%203-6%201-6l-2-1c0-2-3-3-9-3-4%200-4%200-1%201m-133%206c-4%204-4%205-2%205l4%201c1%201%2012%202%2015%201h4c1%202%204%201%204-1l-2-4c-3-3-3-3-10-3-5%200-6-1-7-2-2-2-2-2-6%203m32%201c-4%204-3%208%201%207%202-1%203%200%204%201s8%201%2010-1l3-1c4%200%206-2%204-4v-4h-14l-5-1-3%203M17%2073l-1%2025-1%203a737%20737%200%20012%2039v40h94v-23H46l-1-22v-21h13l13-1H45v-8c0-7%200-8%202-8l2%204c1%203%202%203%203-1%200-4%203-5%204-1%201%202%201%202%203%201%202-2%207-2%207%201%200%201%201%202%203%202%203%201%204%200%204-2l1-2c2-1%204%200%204%203s2%203%205%200c3-4%201-13-4-15h-4c-1%201-1%200-1-3l-1-4c-2-2-1-3%203-3h4V65l-1-11-1%202c-1%201-1%200-2-2v13H64l-15%201h-4V47H17v26m111-4v111h27V85l1-38h-28v22m-36-2c-3%200-4%201-6%206v4l1%208v26l4%201c2%200%202%200%202-4%200-6%203-7%204-1l2%205%208-1h9l1-43c-1-1-21-2-25-1m230%2018c0%2012%200%2014%202%2014l1-4c0-3%205-13%207-13l1%202c1%202%201%202%202%201v-2l1-2v-6l-1-4v3c0%206-4%206-4%201%200-6-4-6-4%200v4l-2-4-2-4-1%2014m-132%2021v12c1%202%2013%203%2017%201%203-1%203-1%203-7v-6l-10-1-10%201M0%20170\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a0a99d7b2f8bc13dec54f9a28a351e3e/ca0a1/techletter.app-screenshot-1562081681779.webp 223w", "/static/a0a99d7b2f8bc13dec54f9a28a351e3e/75680/techletter.app-screenshot-1562081681779.webp 445w", "/static/a0a99d7b2f8bc13dec54f9a28a351e3e/0ba47/techletter.app-screenshot-1562081681779.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a0a99d7b2f8bc13dec54f9a28a351e3e/e92b6/techletter.app-screenshot-1562081681779.png 223w", "/static/a0a99d7b2f8bc13dec54f9a28a351e3e/e66bf/techletter.app-screenshot-1562081681779.png 445w", "/static/a0a99d7b2f8bc13dec54f9a28a351e3e/6af66/techletter.app-screenshot-1562081681779.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a0a99d7b2f8bc13dec54f9a28a351e3e/6af66/techletter.app-screenshot-1562081681779.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The answer is yes, both. Lemme explain 👇`}</p>
    <p>{`In the video Casey makes a point that life is like going the wrong way on a conveyor belt. Stand still and move backwards. You gotta hustle to get ahead. Run faster than the belt.`}</p>
    <p>{`But does hustle actually work or is it just a platitude?`}</p>
    <p>{`We live in a probabilistic universe so nothing is ever guaranteed. Luck plays a HUGE role. "Luck" doesn't mean what you think it means, however. You can create luck.`}</p>
    <p>{`Back in 1713 Bernoulli derived a formula for the expected outcome of a series of independent experiments. How likely are you to get at least N heads after flipping a coin K times?`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Bernoulli_trial"
      }}>{`https://en.wikipedia.org/wiki/Bernoulli_trial`}</a></p>
    <p>{`Here's the formula:`}</p>
    <p>{`N over K multiplied by probability(heads)^K times probability(not_heads)^N-K`}</p>
    <p><img parentName="p" {...{
        "src": "/e27c1fde2321de873cd7f811265e752e/a80ecac0900ddjdc.svg",
        "alt": null
      }}></img></p>
    <p>{`Math is hard and this is 2019 so you can use Wolfram Alpha and iteration to figure out your chance of success.`}</p>
    <p>{`Say each of your things has a 10% chance of going viral 👉 P=0.1, Q= 1-0.1 = 0.9`}</p>
    <p>{`According to Bernoulli you can expect at least 1 success after 10 things with a 65% probability.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.wolframalpha.com/input/?i=10+trials+p%3D0.1"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "89.68609865470853%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'358\\'%20viewBox=\\'0%200%20400%20358\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%20110v30h95v-29a308%20308%200%2000-2%2027%20564%20564%200%2001-74%200l-9%201c-7%200-8%200-9-2a427%20427%200%2001-1-27M15%2095l-1%202v7l-1%202v2c1%200%202%201%201%202l1%201-1%202-1%202%201%205c0%205%200%205%203%205%202%200%202%200%201-2l-2-3v-1c2-1%202-3%201-10l1-11v-3h-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/dca79b37010dea2d5d1c5ce418dc42d6/ca0a1/Mua3GPg.webp 223w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/75680/Mua3GPg.webp 445w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/8d1ba/Mua3GPg.webp 890w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/3838e/Mua3GPg.webp 1335w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/e8009/Mua3GPg.webp 1522w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/dca79b37010dea2d5d1c5ce418dc42d6/e92b6/Mua3GPg.png 223w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/e66bf/Mua3GPg.png 445w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/4ef49/Mua3GPg.png 890w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/4e814/Mua3GPg.png 1335w", "/static/dca79b37010dea2d5d1c5ce418dc42d6/78363/Mua3GPg.png 1522w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/dca79b37010dea2d5d1c5ce418dc42d6/4ef49/Mua3GPg.png",
              "alt": "Mua3GPg",
              "title": "Mua3GPg",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`The same is true for everything you do. Applying for jobs, launching side projects, creating open source, founding startups, companies, or just cooking a fantastic meal.`}</p>
    <p>{`Take probability of success, add hustle, use Bernoulli to see how long it takes :)`}</p>
    <p>{`Sure, life isn't quite a series of independent experiments 👉Your experience compounds, you learn stuff, you get more resources. Bernoulli trials are still a great framework to keep in mind.`}</p>
    <p>{`The more often you try, the more likely you are to succeed.`}</p>
    <p>{`Enjoy your 4-day weekend ✌️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      